"use strict";

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _omit2 = _interopRequireDefault(require("lodash/omit"));

var _debounce2 = _interopRequireDefault(require("lodash/debounce"));

var _bindAll2 = _interopRequireDefault(require("lodash/bindAll"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _currency = require("@nerdwallet/currency");

var _helpers = require("./lib/helpers");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var propTypes = {
  /**
   * String passed to numeral to format the input
   */
  formatMask: _propTypes["default"].string,

  /**
   * Amount of time in MS to wait until formatting
   */
  formatTimer: _propTypes["default"].number,

  /**
   * Initial value of the input
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  // eslint-disable-line react/require-default-props
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyPress: _propTypes["default"].func
};
var defaultProps = {
  formatMask: '0.[000]%',
  formatTimer: 3000,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {},
  onKeyPress: function onKeyPress() {}
};

var PercentageInput = /*#__PURE__*/function (_Component) {
  _inherits(PercentageInput, _Component);

  var _super = _createSuper(PercentageInput);

  function PercentageInput(props) {
    var _this;

    _classCallCheck(this, PercentageInput);

    _this = _super.call(this, props);
    _this.state = (0, _helpers.getUpdatedState)(props.value, props.formatMask);
    _this.debouncedFormatter = (0, _debounce2["default"])(_this.formatter, props.formatTimer);
    (0, _bindAll2["default"])(_assertThisInitialized(_this), ['onBlur', 'onChange', 'onClick', 'onKeyDown', 'onKeyPress']);
    return _this;
  } // eslint-disable-next-line react/no-deprecated -- directive added automatically by Shepherd migration


  _createClass(PercentageInput, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        this.setState((0, _helpers.getUpdatedState)(nextProps.value, nextProps.formatMask));
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      var _this2 = this;

      this.setState((0, _helpers.getUpdatedState)(e.target.value, this.props.formatMask), function () {
        var formattedEvent = (0, _helpers.formatEvent)(_this2.state.formattedValue);

        _this2.debouncedFormatter.cancel();

        _this2.props.onChange(formattedEvent);

        _this2.props.onBlur(formattedEvent);
      });
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      var updatedState = (0, _helpers.getUpdatedState)(e.target.value);
      this.setState(updatedState, this.debouncedFormatter);
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      this.debouncedFormatter(); // reset timer

      this.props.onClick(e);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      this.debouncedFormatter(); // reset timer

      this.props.onKeyDown(e);
    }
  }, {
    key: "onKeyPress",
    value: function onKeyPress(e) {
      if (!(0, _helpers.isKeyAllowed)(e)) {
        e.preventDefault();
      } // if user hits 'Enter', commit value immediately


      if (e.key === 'Enter') {
        var updatedState = (0, _helpers.getUpdatedState)(e.target.value, this.props.formatMask);
        var formattedEvent = (0, _helpers.formatEvent)(updatedState.formattedValue);
        this.debouncedFormatter.cancel();
        this.props.onChange(formattedEvent);
        this.setState(updatedState);
      } else {
        this.debouncedFormatter(); // reset timer
      }

      this.props.onKeyPress(e);
    }
  }, {
    key: "formatter",
    value: function formatter() {
      var _this3 = this;

      if ((0, _helpers.hasNoValue)(this.state.rawValue)) {
        this.props.onChange((0, _helpers.formatEvent)(''));
        return;
      }

      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        // eslint-disable-next-line react/no-access-state-in-setstate -- directive added automatically by Shepherd migration
        formattedValue: (0, _helpers.formatValue)(this.state.rawValue, this.props.formatMask)
      }), function () {
        _this3.props.onChange((0, _helpers.formatEvent)(_this3.state.formattedValue));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_currency.Input, _extends({}, (0, _omit2["default"])(this.props, Object.keys(propTypes)), {
        onBlur: this.onBlur,
        onChange: this.onChange,
        onClick: this.onClick,
        onKeyDown: this.onKeyDown,
        onKeyPress: this.onKeyPress,
        value: this.state.formattedValue
      }));
    }
  }]);

  return PercentageInput;
}(_react.Component);

_defineProperty(PercentageInput, "displayName", 'PercentageInput');

_defineProperty(PercentageInput, "propTypes", propTypes);

_defineProperty(PercentageInput, "defaultProps", defaultProps);

var _default = PercentageInput;
exports["default"] = _default;